/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TriggerUserMigrationDto
 */
export interface TriggerUserMigrationDto {
    /**
     * Delete existing tenant users and re-import with correct password hashes
     * @type {boolean}
     * @memberof TriggerUserMigrationDto
     */
    remigrate?: boolean;
    /**
     * Filter migration by user type
     * @type {string}
     * @memberof TriggerUserMigrationDto
     */
    filterType?: TriggerUserMigrationDtoFilterTypeEnum;
}


/**
 * @export
 */
export const TriggerUserMigrationDtoFilterTypeEnum = {
    Admin: 'admin',
    Provider: 'provider',
    Patient: 'patient'
} as const;
export type TriggerUserMigrationDtoFilterTypeEnum = typeof TriggerUserMigrationDtoFilterTypeEnum[keyof typeof TriggerUserMigrationDtoFilterTypeEnum];


/**
 * Check if a given object implements the TriggerUserMigrationDto interface.
 */
export function instanceOfTriggerUserMigrationDto(value: object): value is TriggerUserMigrationDto {
    return true;
}

export function TriggerUserMigrationDtoFromJSON(json: any): TriggerUserMigrationDto {
    return TriggerUserMigrationDtoFromJSONTyped(json, false);
}

export function TriggerUserMigrationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerUserMigrationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'remigrate': json['remigrate'] == null ? undefined : json['remigrate'],
        'filterType': json['filterType'] == null ? undefined : json['filterType'],
    };
}

export function TriggerUserMigrationDtoToJSON(json: any): TriggerUserMigrationDto {
    return TriggerUserMigrationDtoToJSONTyped(json, false);
}

export function TriggerUserMigrationDtoToJSONTyped(value?: TriggerUserMigrationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remigrate': value['remigrate'],
        'filterType': value['filterType'],
    };
}

